import { makeStyles } from '@material-ui/core';
import { ISpcTheme } from '../../../../../../common/theme/ISpcTheme';

export type InformativeSectionContainerClasses = 'informativeItem' | 'container';

const informativeSectionContainerStyles = makeStyles<ISpcTheme, InformativeSectionContainerClasses>(
  theme => ({
    container: {
      minWidth: '80px',
      [theme.breakpoints.down('xs')]: {
        minWidth: 'auto',
      },
    },
    informativeItem: {
      padding: '0 14px',
      textAlign: 'center',
      [theme.breakpoints.down('md')]: {
        padding: '0 12px',
      },
      [theme.breakpoints.down('xs')]: {
        padding: '0 8px',
      },
    },
  }),
  { name: 'Customise_InformativeSectionContainer' },
);

export default informativeSectionContainerStyles;
